import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import InventoryPreview from "@/components/site/InventoryPreview";
import Marquee from "@/components/site/Marquee";
import Sales from "@/components/site/Sales";
import Services from "@/components/site/Services";
import ParallaxDivider from "@/components/site/ParallaxDivider";
import Capabilities from "@/components/site/Capabilities";
import Manifesto from "@/components/site/Manifesto";
import Record from "@/components/site/Record";
import Safety from "@/components/site/Safety";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Home() {
  return (
    <main className="relative bg-background text-foreground" data-testid="home-page">
      <Nav />
      <Hero />
      <Marquee />
      <InventoryPreview />
      <Sales />
      <Services />
      <ParallaxDivider />
      <Capabilities />
      <Manifesto />
      <Record />
      <Safety />
      <Contact />
      <Footer />
    </main>
  );
}
